import * as React from 'react';
import { DomainsDescriptionId } from '@models/feature-descriptor-domain';

export const DomainsDescriptionsSelectionContext = React.createContext<
  | undefined
  | [
      Map<DomainsDescriptionId.String, DomainsDescriptionId>,
      {
        toggleSelection: (check: boolean, ids: DomainsDescriptionId[]) => void;
      }
    ]
>(undefined);

export function useDomainsDescriptionsSelectionContext() {
  const context = React.useContext(DomainsDescriptionsSelectionContext);
  if (context === undefined) {
    throw new Error(
      'useDomainsDescriptionsSelectionContext must be used within a DomainsDescriptionsSelectionContext'
    );
  }
  return context;
}

interface DomainsDescriptionsSelectionContextProps {
  selectedDomainDescriptionIds: DomainsDescriptionId[];
  setSelectedDomainDescriptionIds: (ids: DomainsDescriptionId[]) => void;
}

export function DomainsDescriptionsSelectionContextProvider(
  props: React.PropsWithChildren<DomainsDescriptionsSelectionContextProps>
) {
  const selectedDomainDescriptionsIds: Map<string, DomainsDescriptionId> =
    React.useMemo(
      () => DomainsDescriptionId.listToMap(props.selectedDomainDescriptionIds),
      [props.selectedDomainDescriptionIds]
    );

  function toggleSelection(check: boolean, ids: DomainsDescriptionId[]) {
    ids.forEach(id => {
      if (check) {
        selectedDomainDescriptionsIds.set(
          DomainsDescriptionId.toString(id),
          id
        );
      } else {
        selectedDomainDescriptionsIds.delete(DomainsDescriptionId.toString(id));
      }
    });

    props.setSelectedDomainDescriptionIds(
      Array.from(selectedDomainDescriptionsIds.values())
    );
  }

  return (
    <DomainsDescriptionsSelectionContext.Provider
      value={[selectedDomainDescriptionsIds, { toggleSelection }]}
      {...props}
    />
  );
}
